const DIRECTION_TRANSFORMS = {
  down: 'rotate(90 7.5 7.5)',
  left: 'rotate(180 7.5 7.5)',
  right: undefined,
  up: 'rotate(-90 7.5 7.5)'
}

const ArrowIcon = ({ className, direction = 'right' }) => (
  <svg
    aria-hidden='true'
    className={className}
    height='15'
    viewBox='0 0 15 15'
    fill='none'
    width='15'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g transform={DIRECTION_TRANSFORMS[direction]}>
      <path
        d='M0.962618 8.48782H11.7151L7.01749 13.3084C6.64207 13.6936 6.64207 14.3258 7.01749 14.7111C7.39291 15.0963 7.99936 15.0963 8.37478 14.7111L14.7184 8.20135C15.0939 7.8161 15.0939 7.19378 14.7184 6.80853L8.38441 0.288936C8.00898 -0.0963121 7.40253 -0.0963121 7.02711 0.288936C6.65169 0.674185 6.65169 1.29651 7.02711 1.68176L11.7151 6.51218H0.962618C0.433178 6.51218 0 6.9567 0 7.5C0 8.0433 0.433178 8.48782 0.962618 8.48782Z'
        fill='currentColor'
      />
    </g>
  </svg>
)

export default ArrowIcon
